export const HoursOfOperation = ({open, close}) => {
  return (
    <div className="time">
      <div className="text-primary-blue">Hours of Operation</div>
      <span>{open}</span> - <span>{close}</span>
    </div>
  );
};
